module.exports = __webpack_public_path__ + "img/img_5.1d61ccd7.png";